
import { defineComponent, PropType, ref, onMounted, watch } from "vue";
import Symbol from "../Symbol.vue";
import ScrollableContent from "@/components/ScrollableContent.vue";
import AsDataTable from "@/components/AsDataTable.vue";
import ModalView from "@/components/Modal/Modal.vue";
import { currencyFormat } from "@/core/helpers/momentUtil";
export type ListModel = {
  avatar?: string;
  text: string;
  textLink?: string;
  description?: string;
  value?: string;
  rawValue?: string;
};
export default defineComponent({
  components: { Symbol, ScrollableContent, AsDataTable, ModalView },
  name: "list-widget",
  emits: ["showAllClick"],
  props: {
    id: String,
    customClasses: String,
    title: String,
    subtitle: String,
    modalSubTitle: String,
    modalSubTitleSign: String,
    scroll: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: String,
      default: "500px",
    },
    items: {
      type: Array as PropType<Array<ListModel>>,
      default: () => [],
    },
    modalItems: {
      type: Array,
      default: () => [],
    },
    modalHeader: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const showAllmodal = ref<null | typeof ModalView>(null);
    const random = Math.floor(Math.random() * 100000);
    var showAllText = ref("Tümünü Göster");
    var modalSubTitleText = ref("");
    var showAllStatus = ref(false);
    var scrollStatus = ref(props.scroll);
    var scrollH = ref(props.scrollHeight);
    onMounted(() => {
      getModalSubTitle();
    });
    watch(
      () => props.modalItems,
      () => {
        getModalSubTitle();
      }
    );
    function getModalSubTitle() {
      if (props.modalSubTitle) {
        if (props.modalSubTitle == "sum") {
          modalSubTitleText.value =
            "Toplam: " +
            currencyFormat(
              props.modalItems
                .map((s) => parseFloat((s as any).rawValue!))
                .reduce((a, b) => a + b, 0),
              true
            );
        }
      }
    }

    function showAll() {
      showAllStatus.value = true;
      if (showAllStatus.value) {
        showAllmodal.value?.show();
      }

      context.emit("showAllClick", showAllStatus.value, props.id);
    }

    return {
      random,
      showAll,
      showAllText,
      scrollStatus,
      scrollH,
      showAllmodal,
      modalSubTitleText,
    };
  },
});
